import { render } from "./ServiceProvider.vue?vue&type=template&id=134c97b6&scoped=true"
import script from "./ServiceProvider.vue?vue&type=script&lang=js"
export * from "./ServiceProvider.vue?vue&type=script&lang=js"

import "./ServiceProvider.vue?vue&type=style&index=0&id=134c97b6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134c97b6"]])

export default __exports__